require('../../modules/es6.string.iterator');
require('../../modules/es6.array.from');
module.exports = require('../../modules/_core').Array.from;


//////////////////
// WEBPACK FOOTER
// /app/node_modules/core-js/library/fn/array/from.js
// module id = 855
// module chunks = 0